import { createSlice } from "@reduxjs/toolkit";

import { userSavedSearchEntityAdapter } from "./adapter";

const userSavedSearchesSlice = createSlice({
  name: "userSavedSearches",
  initialState: userSavedSearchEntityAdapter.getInitialState(),
  reducers: {
    setAll: userSavedSearchEntityAdapter.setAll,
    setOne: userSavedSearchEntityAdapter.setOne,
    setMany: userSavedSearchEntityAdapter.setMany,
    addOne: userSavedSearchEntityAdapter.addOne,
    removeOne: userSavedSearchEntityAdapter.removeOne,
    removeAll: userSavedSearchEntityAdapter.removeAll,
  },
});

export const { actions } = userSavedSearchesSlice;

export default {
  userSavedSearches: userSavedSearchesSlice.reducer,
};
